module.exports = __webpack_public_path__ + "img/2-draw.225d6601.png";